import React, { FC } from "react";

import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Bold } from "@UI/Components/Bold/Bold";
import { ListItem } from "@UI/Components/List/List";
import { Text } from "@UI/Components/Text/Text";
import { Box } from "@UI/Components/Box/Box";
import { Rate } from "@Shared/Components/Rate/Rate";
import { OrderDescriptionColorScheme } from "@modules/Purchasing/Components/OrderDescription/types";
import { getDarkBorderColor } from "../../../Purchasing/Components/OrderDescription/config";
import messages from "./messages";
import serviceRequestMessages from "@modules/ServiceRequest/Components/messages";
import { IServiceOffer } from "@modules/ServiceAssignment/services/serviceOffers";

interface Props {
  rateCents: number;
  rateCurrency: IServiceOffer["rateCurrency"];
  billingUnit: IServiceOffer["billingUnit"];
  prepaidCents: number;
  serviceFeeCents: number;
  totalExpenses: number;
  totalExpensesFees: number;
  colorScheme?: OrderDescriptionColorScheme;
  includeFees?: boolean;
  preview?: boolean;
  includeAdvancePayment?: boolean;
  isEstimate?: boolean;
}

const TOTAL_LABEL_FOR_BILLING_UNIT = {
  hour: messages.totalByHour,
  day: messages.totalByDay,
  week: messages.totalByWeek,
};

// The includeFees and includeAdvancePayment props are used for the serviceOffer Modal.
// In that step(When the SP has made an offer, we don't want to show the fees or advance payment yet)
export const TotalServiceOffer: FC<Props> = ({
  rateCents,
  rateCurrency,
  billingUnit,
  prepaidCents,
  serviceFeeCents,
  totalExpenses,
  totalExpensesFees,
  colorScheme,
  includeFees,
  preview,
  includeAdvancePayment,
  isEstimate,
}) => {
  const borderColor = getDarkBorderColor(colorScheme);

  const totalExpensesPrice = totalExpenses + totalExpensesFees;

  const totalBasePrice = rateCents;
  const totalPriceWithFees = rateCents + serviceFeeCents;

  const totalExpensesWithFees = includeFees
    ? totalExpensesPrice
    : totalExpenses;
  const totalRate = includeFees ? totalPriceWithFees : totalBasePrice;
  const totalFinalAmount =
    totalRate +
    totalExpensesWithFees -
    (includeAdvancePayment ? prepaidCents : 0);

  return (
    <ListItem
      display="flex"
      justifyContent="space-between"
      borderTopColor={borderColor}
      borderTopWidth="1px"
      pt="5"
    >
      {/* <Bold fontSize="lg">
        {billingUnit !== "flat" && preview ? (
          <FormattedMessage {...TOTAL_LABEL_FOR_BILLING_UNIT[billingUnit]} />
        ) : (
          <FormattedMessage {...messages.total} />
        )}
      </Bold>
      <Box textAlign="right">
        {billingUnit !== "flat" && preview ? (
          <>
            <Box>
              <Bold fontSize={{ base: "lg", lg: "xl" }}>
                <Rate
                  cents={
                    !isSubscribed
                      ? rateCents + rateCents * (serviceFeePercentage / 100)
                      : rateCents
                  }
                  currency={rateCurrency}
                  unit={billingUnit}
                />
              </Bold>
            </Box>

            {totalExpenses + (totalExpensesFees ?? 0) > 0 && (
              <>
                <Text as="span" fontSize="md">
                  +{" "}
                  <Rate
                    cents={
                      !isSubscribed
                        ? totalExpenses +
                          totalExpenses * (serviceFeePercentage / 100)
                        : totalExpenses
                    }
                    currency={rateCurrency}
                    unit="flat"
                  />
                </Text>
              </>
            )}
          </>
        ) : (
          <Bold fontSize={{ base: "lg", lg: "xl" }}>
            <Rate
              cents={
                !isSubscribed
                  ? totalFinalAmount +
                    totalFinalAmount * (serviceFeePercentage / 100)
                  : totalFinalAmount
              }
              currency={rateCurrency}
              unit="flat"
            />
          </Bold>
        )}
      </Box> */}

      <Bold fontSize="lg">
        {billingUnit !== "flat" && preview ? (
          <FormattedMessage {...TOTAL_LABEL_FOR_BILLING_UNIT[billingUnit]} />
        ) : (
          <FormattedMessage {...messages.total} />
        )}
      </Bold>
      <Box textAlign="right">
        {isEstimate ? (
          <Bold fontSize={{ base: "lg", lg: "xl" }}>
            <FormattedMessage {...serviceRequestMessages["serviceRequest.visitOfferDetail.status"]} />
          </Bold>
        ) : billingUnit !== "flat" && preview ? (
          <>
            <Box>
              <Bold fontSize={{ base: "lg", lg: "xl" }}>
                <Rate
                  cents={totalRate}
                  currency={rateCurrency}
                  unit={billingUnit}
                />
              </Bold>
            </Box>

            {totalExpenses + totalExpensesFees > 0 && (
              <>
                <Text as="span" fontSize="md">
                  (+{" "}
                  <Rate
                    cents={totalExpensesWithFees}
                    currency={rateCurrency}
                    unit="flat"
                  />
                  )
                </Text>
              </>
            )}
          </>
        ) : (
          <Bold fontSize={{ base: "lg", lg: "xl" }}>
            <Rate
              cents={totalFinalAmount}
              currency={rateCurrency}
              unit="flat"
            />
          </Bold>
        )}
      </Box>
    </ListItem>
  );
};
